import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';

import { status } from 'constants/general';
import circlesStrings from 'modules/circles/strings';
import ClosedCirclesHeader from 'modules/circles/components/ClosedCirclesHeader';
import ClosedCirclesFilter from 'modules/circles/components/ClosedCirclesFilter';
import ClosedCirclesList from 'modules/circles/components/ClosedCirclesList';
import Pagination from 'modules/common/components/Pagination';
import Loader from 'modules/common/components/Loader';
import Popup from 'modules/common/components/Popup';

import {
  ClosedCirclesWrapper,
  LoaderWrapper,
  NoResultsWrapper,
  NoResultsText,
  PaginationWrapper,
  ImgPreview,
  VideoPreview,
  VideoPreviewSrc,
  ToastTextOverlay,
} from './ClosedCirclesComponent.style';

const ClosedCirclesComponent = ({
  showCopiedTextOverlay,
  searchQuery,
  selectedPageFilter,
  isPreviewFilePopupOpen,
  previewFileData,
  isActionPopupOpen,
  isActionPopupLoading,
  actionPopupStatus,
  handleDoctorsPaginationClick,
  handleTextToCopyToClipboardClick,
  handleSearchBarInputChange,
  handlePreviewFileClick,
  handleActionBtnClick,
  handleActionPopupConfirmBtnClick,
  handleActionPopupDismissBtnClick,
}) => {
  const { closedCirclesList } = useSelector(state => ({
    closedCirclesList: state.circles.closedCirclesList,
  }));

  const totalResultsCount = closedCirclesList?.details?.totalCount;
  const numberOfPages = (totalResultsCount && Math.ceil(totalResultsCount / 10)) || 1;
  const closedCirclesListArr = closedCirclesList?.details?.results;

  const renderClosedCirclesList = () => {
    if (
      closedCirclesList.status === status.SHOULD_CALL_API ||
      closedCirclesList.status === status.FETCHING
    )
      return (
        <LoaderWrapper>
          <Loader />
        </LoaderWrapper>
      );

    if (
      (closedCirclesList.status === status.SUCCESS && closedCirclesListArr?.length === 0) ||
      closedCirclesList.status === status.FAIL
    )
      return (
        <NoResultsWrapper>
          <NoResultsText>
            {circlesStrings.closedCirclesList.closedCirclesGridNoResultsFound}
          </NoResultsText>
        </NoResultsWrapper>
      );

    return (
      <>
        <ClosedCirclesList
          closedCirclesListArr={closedCirclesListArr}
          isActionPopupOpen={isActionPopupOpen}
          isActionPopupLoading={isActionPopupLoading}
          actionPopupStatus={actionPopupStatus}
          handleTextToCopyToClipboardClick={handleTextToCopyToClipboardClick}
          handlePreviewFileClick={handlePreviewFileClick}
          handleActionBtnClick={handleActionBtnClick}
          handleActionPopupConfirmBtnClick={handleActionPopupConfirmBtnClick}
          handleActionPopupDismissBtnClick={handleActionPopupDismissBtnClick}
        />
        {numberOfPages > 1 && (
          <PaginationWrapper>
            <Pagination
              currentPage={selectedPageFilter}
              totalCount={numberOfPages}
              handlePaginationClick={handleDoctorsPaginationClick}
            />
          </PaginationWrapper>
        )}
        {isPreviewFilePopupOpen && (
          <Popup handleCloseBtnClick={() => handlePreviewFileClick(false)}>
            {(previewFileData.type === 'image' && <ImgPreview src={previewFileData.url} />) || (
              <VideoPreview controls>
                <VideoPreviewSrc src={previewFileData.url} />
              </VideoPreview>
            )}
          </Popup>
        )}
        {showCopiedTextOverlay && (
          <ToastTextOverlay>
            {circlesStrings.closedCirclesList.copiedToClipboardText}
          </ToastTextOverlay>
        )}
      </>
    );
  };

  return (
    <>
      <ClosedCirclesHeader />
      <ClosedCirclesWrapper>
        <ClosedCirclesFilter
          searchQuery={searchQuery}
          handleSearchBarInputChange={handleSearchBarInputChange}
        />
        {renderClosedCirclesList()}
      </ClosedCirclesWrapper>
    </>
  );
};

ClosedCirclesComponent.propTypes = {
  showCopiedTextOverlay: PropTypes.bool.isRequired,
  searchQuery: PropTypes.string.isRequired,
  selectedPageFilter: PropTypes.number.isRequired,
  isPreviewFilePopupOpen: PropTypes.bool.isRequired,
  previewFileData: PropTypes.shape({
    type: PropTypes.string,
    url: PropTypes.string,
  }).isRequired,
  isActionPopupOpen: PropTypes.bool.isRequired,
  isActionPopupLoading: PropTypes.bool.isRequired,
  actionPopupStatus: PropTypes.shape({}).isRequired,
  handleDoctorsPaginationClick: PropTypes.func.isRequired,
  handleTextToCopyToClipboardClick: PropTypes.func.isRequired,
  handleSearchBarInputChange: PropTypes.func.isRequired,
  handlePreviewFileClick: PropTypes.func.isRequired,
  handleActionBtnClick: PropTypes.func.isRequired,
  handleActionPopupConfirmBtnClick: PropTypes.func.isRequired,
  handleActionPopupDismissBtnClick: PropTypes.func.isRequired,
};

export default ClosedCirclesComponent;
